import { CultureIndexCulture } from '../culture';
import { CultureIndexPhenologicalStage } from '../phenologicalStage';
import { CultureIndexMapData } from './getMapData';

export interface CultureIndexAreaMapParams {
  culture: CultureIndexCulture | undefined;
  forecastDate: string | undefined;
  periodStart: string | undefined;
  periodEnd: string | undefined;
  stage: CultureIndexPhenologicalStage | undefined;
}

export interface CultureIndexAreaMapError {
  title: string;
  message: string;
}

export interface CultureIndexAreaMap {
  id: number;
  data: CultureIndexMapData | undefined;
  error: CultureIndexAreaMapError | undefined;
  params: CultureIndexAreaMapParams;
  filename: string;
  isLoading: boolean;
}

export const emptyMapParams: CultureIndexAreaMapParams = {
  culture: undefined,
  forecastDate: undefined,
  periodStart: undefined,
  periodEnd: undefined,
  stage: undefined,
};
